export const SELECTED_PICKING_CHANGED = 'SELECTED_PICKING_CHANGED'

export function selectedPickingChanged(picking) {
  return {
    type: SELECTED_PICKING_CHANGED,
    picking,
  }
}
